module.exports = __webpack_public_path__ + "assets/img/intro-vip-a1.e614b48c.jpg";